<template>
  <div @keyup.enter="validarTelefono()">
    <TemplateCambios>
      <div class="cabecera">
        Cambiar Teléfono
      </div>

      <div class="texto">
        Indícanos tu nuevo número de teléfono
      </div>

      <div>
        <input
          id="nuevoTelefono"
          v-model.trim="nuevoTelefono"
          type="tel"
          class="pure-input"
          placeholder="Nº Teléfono sin espacios"
          maxlength="10"
          required
          @keydown="errorTelefono = null"
        />
      </div>
      <div v-if="errorTelefono" class="noValido">{{ errorTelefono }}</div>
      <br />
      <br />
      <button class="pure-button boton" @click="validarTelefono()">
        Continuar
      </button>
    </TemplateCambios>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nuevoTelefono: "",
      errorTelefono: ""
    };
  },

  computed: {},

  methods: {
    validarTelefono() {
      console.log("Validar telefono");
      let expresionRegular = /^([9,7,6]{1})+([0-9]{8})$/;
      this.errorTelefono = "";

      if (this.nuevoTelefono.length < 1) {
        this.errorTelefono = "Escriba un número de teléfono";
        return;
      }

      if (!expresionRegular.test(this.nuevoTelefono)) {
        this.errorTelefono = "Número de telefono incorrecto";
        return;
      }

      this.$store.dispatch("setNuevoTelefono", this.nuevoTelefono);
      this.$emit("siguiente");
    }
  }
};
</script>

<style scoped>
input {
  width: 100%;
  min-width: 15rem;
}
</style>
